export const httpStatusCode = {
  success: 200,
  unauthorized: 401,
  error: 404,
  notFound: 404
} as const;

// Milliseconds to wait before redirecting.
export const delayBeforeRedirect = 3000;

// Milliseconds to wait before hiding success message.
export const delayBeforeHideSuccessMessage = 4000;

// Milliseconds to wait before hiding failure message.
export const delayBeforeHideFailureMessage = 8000;

// Configuration for multiple messages shown across the UI
export const messages = {
  hasExternalSubscription: {
    className: "warning",
    content:
      "Account managed from Azure AD. " +
      "Request your Enterprise Application manager to edit these options."
  }
} as const;

export const recoveryCodeFilename = "urbansim-recovery-code.txt" as const;
